<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <section>
      <ValidationObserver 
        ref="form">
        <v-form>
          <div 
            class="title font-weight-bold black--text mb-6"
            style="opacity: 70%;">
            #Personal Sentana
          </div>

          <v-row
            style="min-height: 64.6vh;">
            <v-col 
              cols="12" 
              md="6"
              class="py-0">
              <!-- <ValidationProvider 
                name="nik" 
                rules="min:16|max:16" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Nomor Induk Kependudukan
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 60}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. 3310062008XXXXXX"
                  hide-details

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"

                  v-uppercase

                  v-model="form.nik"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nomor Induk Kependudukan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.nik !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <div
                class="mb-6">
                <div class="body-2 mb-2">
                  Upload Nomor Induk Kependudukan
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <uploadfolder v-model="upload.folder_nik"
                  style="width: 400px; height: 250px;">
                  <div 
                    slot="activator" 
                    class="cursor-pointer">
                    <v-card 
                      flat
                      width="400"
                      height="250"
                      class="d-flex align-center justify-center"
                      style="border-radius: 15px;
                            border: 2px solid #eaeaea; 
                            border-style: dashed;">
                      <v-img v-if="!process.image_nik && form.nik_url !== ''"
                        alt="kominfo" 
                        width="396"
                        height="246"
                        gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                        :src="form.nik_url"
                        class="ma-auto d-flex align-center text-center">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>

                        <v-icon 
                          size="50" 
                          color="white">
                          mdi-cloud-upload-outline
                        </v-icon>
                      </v-img>

                      <v-icon v-if="!process.image_nik && form.nik_url === ''"
                        size="50" 
                        color="grey">
                        mdi-cloud-upload-outline
                      </v-icon>

                      <v-progress-circular v-if="process.image_nik"
                        indeterminate
                        :color="set_color">
                      </v-progress-circular>
                    </v-card>
                  </div>
                </uploadfolder>
              </div> -->

              <ValidationProvider 
                name="kk" 
                rules="min:16|max:16" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Nomor Kartu Keluarga
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 60}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. 3310062008XXXXXX"
                  hide-details
                  clearable
                  @click:clear="form.kk = ''"

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"

                  v-uppercase

                  v-model="form.kk"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nomor Kartu Keluarga {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.kk !== '' && valid && form.kk !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <div
                class="mb-6">
                <div class="body-2 mb-2">
                  Upload Kartu Keluarga
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-card
                  width="500"
                  flat
                  height="300">
                  <v-btn
                    @click="form.kk_url = ''"
                    v-if="form.kk_url !== ''"
                    icon
                    style="position: absolute; top: -15px; right: -15px; z-index: 1;">
                    <v-icon
                      color="red">
                      mdi-close-circle
                    </v-icon>
                  </v-btn>

                  <uploadfolder v-model="upload.folder_kk"
                    style="width: 500px; height: 300px;">
                    <div 
                      slot="activator" 
                      class="cursor-pointer">
                      <v-card 
                        flat
                        width="500"
                        height="300"
                        class="d-flex align-center justify-center"
                        style="border-radius: 15px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;">
                        <v-img v-if="!process.image_kk && form.kk_url !== ''"
                          alt="kominfo" 
                          width="496"
                          height="296"
                          gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                          :src="form.kk_url"
                          class="ma-auto d-flex align-center text-center">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>

                          <v-icon 
                            size="50" 
                            color="white">
                            mdi-cloud-upload-outline
                          </v-icon>
                        </v-img>

                        <v-icon v-if="!process.image_kk && form.kk_url === ''"
                          size="50" 
                          color="grey">
                          mdi-cloud-upload-outline
                        </v-icon>

                        <v-progress-circular v-if="process.image_kk"
                          indeterminate
                          :color="set_color">
                        </v-progress-circular>
                      </v-card>
                    </div>
                  </uploadfolder>
                </v-card> 
              </div>

              <ValidationProvider 
                name="npwp" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  NPWP
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 60}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. 00.000.000.0-000.000"
                  hide-details
                  clearable
                  @click:clear="form.npwp = ''"

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"

                  v-uppercase

                  v-model="form.npwp"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        NPWP {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.npwp !== '' && valid && form.npwp !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="birthplace" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Tempat Lahir
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 50}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. Yogyakarta"
                  hide-details
                  clearable
                  @click:clear="form.birthplace = ''"

                  v-uppercase

                  v-model="form.birthplace"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tempat Lahir {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.birthplace !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <v-row>
                <v-col
                  cols="12"
                  md="5"
                  class="py-0">
                  <div>
                    <div class="body-2 mb-2">
                      Tanggal Lahir
                      <!-- <span>
                        (boleh dikosongi)
                      </span> -->
                    </div>

                    <v-menu
                      ref="birthdate"
                      min-width="290px"
                      max-width="290px"
                      transition="scale-transition"
                      offset-y
                      :nudge-right="40"
                      :close-on-content-click="false"
                      v-model="picker">
                      <template v-slot:activator="{ on, attrs }">
                        <ValidationProvider 
                          name="birthdate" 
                          v-slot="{ errors, valid }">
                          <v-text-field
                            class="mb-6"
                            readonly
                            filled
                            rounded
                            dense
                            :color="set_color"
                            placeholder="2023-01-01"
                            hide-details
                            clearable
                            @click:clear="form.birthdate = ''"

                            v-uppercase

                            v-model="form.birthdate"
                            v-on="on"
                            v-bind="attrs"
                            :success="form.birthdate !== '' && valid"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Tanggal Lahir {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.birthdate !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </template>

                      <v-date-picker 
                        :color="set_color"
                        v-model="form.birthdate"
                        @input="picker = false">
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="7"
                  class="py-0">
                  <div class="body-2 mb-4">
                    #Usia
                  </div>

                  <div
                    class="body-1 font-weight-bold"
                    :class="form.age === 'Belum diketahui' ? 'orange--text' : ''">
                    {{ form.age }}
                  </div>
                </v-col>
              </v-row>

              <!-- <div>
                <div class="body-2 mb-2">
                  Tanggal Lahir
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <v-menu
                  ref="birthdate"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="birthdate" 
                      v-slot="{ errors, valid }">
                      <v-text-field
                        :style="`width: ${rps === 'xs' ? 100 : 35}%`"
                        class="mb-6"
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="2023-01-01"
                        hide-details
                        clearable
                        @click:clear="form.birthdate = ''"

                        v-uppercase

                        v-model="form.birthdate"
                        v-on="on"
                        v-bind="attrs"
                        :success="form.birthdate !== '' && valid"
                        :error-messages="errors"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tanggal Lahir {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.birthdate !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="form.birthdate"
                    @input="picker = false">
                  </v-date-picker>
                </v-menu>
              </div> -->

              <ValidationProvider 
                name="ktp_address" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Alamat KTP
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. Yogyakarta"
                  hide-details
                  clearable
                  @click:clear="form.ktp_address = ''"

                  v-uppercase

                  v-model="form.ktp_address"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Alamat KTP {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.ktp_address !== '' && valid && form.ktp_address !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="domicile_address" 
                v-slot="{ errors, valid }">
                <div class="body-2">
                  Alamat Domisili
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-checkbox
                  v-model="address_same"
                  dense
                  :color="set_color"
                  class="mb-3"
                  hide-details>
                  <template v-slot:label>
                    <span
                      class="body-2 black--text"
                      style="opacity: 40%;">
                      Alamat Domisili sama dengan alamat identitas (KTP)
                    </span>
                  </template>
                </v-checkbox>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. Yogyakarta"
                  hide-details
                  clearable
                  @click:clear="form.domicile_address = ''"

                  v-uppercase

                  v-model="form.domicile_address"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Alamat Domisili {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.domicile_address !== '' && valid && form.domicile_address !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col 
              cols="12" 
              md="6"
              class="py-0">
              <ValidationProvider 
                name="gender" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Jenis Kelamin
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-autocomplete
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. LAKI-LAKI"
                  hide-details
                  clearable
                  @click:clear="form.gender = ''"
                  
                  :items="['LAKI-LAKI', 'PEREMPUAN']"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-uppercase

                  v-model="form.gender"
                  :success="form.gender !== '' && valid"
                  :error-messages="errors"
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Jenis Kelamin {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.gender !== '' && valid && form.gender !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>

              <ValidationProvider 
                name="religion" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Agama
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-select
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. ISLAM"
                  hide-details
                  
                  :items="['ISLAM', 'KATOLIK', 'KRISTEN', 'HINDU', 'BUDHA', 'KONGHUCU']"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"
                  clearable
                  @click:clear="form.religion = ''"

                  v-model="form.religion"
                  :success="form.religion !== '' && valid"
                  :error-messages="errors"
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Agama {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.religion !== '' && valid && form.religion !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <ValidationProvider 
                name="blood_group" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Golongan Darah
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-select
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 35}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. O"
                  hide-details
                  
                  :items="['O', 'A', 'B', 'AB']"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"
                  clearable
                  @click:clear="form.blood_group = ''"

                  v-model="form.blood_group"
                  :success="form.blood_group !== '' && valid"
                  :error-messages="errors"
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Golongan Darah {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.blood_group !== '' && valid && form.blood_group !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <ValidationProvider 
                name="last_education" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Pendidikan Terakhir
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-autocomplete
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 35}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. S1"
                  hide-details
                  
                  :items="['SD', 'SMP', 'SMA', 'D3', 'S1', 'S2', 'S3']"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"
                  clearable
                  @click:clear="form.last_education = ''"

                  v-model="form.last_education"
                  :success="form.last_education !== '' && valid"
                  :error-messages="errors"
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Pendidikan Terakhir {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.last_education !== '' && valid && form.last_education !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>

              <ValidationProvider 
                name="degree_education" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Gelar Pendidikan
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 60}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. S.Kom"
                  hide-details
                  clearable
                  @click:clear="form.degree_education = ''"

                  v-uppercase

                  v-model="form.degree_education"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Gelar Pendidikan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.degree_education !== '' && valid && form.degree_education !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="profession" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Pekerjaan
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. Programer"
                  hide-details
                  clearable
                  @click:clear="form.profession = ''"

                  v-uppercase

                  v-model="form.profession"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Pekerjaan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.profession !== '' && valid && form.profession !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="marital_status" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Status Perkawinan
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-autocomplete
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. KAWIN"
                  hide-details
                  clearable
                  @click:clear="form.marital_status = ''"
                  
                  :items="['KAWIN', 'BELUM KAWIN', 'JANDA', 'DUDA']"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-uppercase

                  v-model="form.marital_status"
                  :success="form.marital_status !== '' && valid"
                  :error-messages="errors"
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Status Perkawinan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.marital_status !== '' && valid && form.marital_status !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-form>

        <div v-if="message.error.length > 0"
          class="text-center my-4">
          <div
            class="error--text d-flex align-center">
            <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>
      </ValidationObserver>

      <div>
        <v-divider 
          class="mb-4" 
          style="border: 3px solid #f0f0f0; border-radius: 50px;"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()"
            color="green"
            elevation="0"
            class="body-2 font-weight-bold white--text text-capitalize"
            style="border-radius: 10px;">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>

            Simpan
          </v-btn>

          <router-link
            to="/sentana">
            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text px-2 ml-2"
              :disabled="process.form"
              style="border-radius: 10px;">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>

              Batal
            </v-btn>
          </router-link>
        </v-card-actions>
      </div>
    </section>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        dialog: {
          snackbar: false
        },
        picker: false,
        upload: {
          folder_nik: null,
          folder_kk: null
        },
        address_same: false,
        process: {
          form: false,
          image_nik: false,
          image_kk: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.folder_nik': {
        handler: function () {
          if (this.upload.folder_nik) {
            this.process.image_nik = this.upload.folder_nik.process

            if (!this.process.image_nik) {
              // CALLBACK FROM UPLOAD IMAGE

              this.form.nik_url = this.upload.folder_nik.fileuri
            }
          }
        },
        deep: true
      },
      'upload.folder_kk': {
        handler: function () {
          if (this.upload.folder_kk) {
            this.process.image_kk = this.upload.folder_kk.process

            if (!this.process.image_kk) {
              // CALLBACK FROM UPLOAD IMAGE

              this.form.kk_url = this.upload.folder_kk.fileuri
            }
          }
        },
        deep: true
      },
      'address_same': function (val) {
        if (val) {
          this.form.domicile_address = this.form.ktp_address
        } else {
          this.form.domicile_address = ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      }
    },
    mounted () {
      this.address_same = this.form.domicile_address !== '' && this.form.domicile_address === this.form.ktp_address ? true : false
    },
    methods: {
      async save () {
        this.message.error = ''
        
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          let forms = Object.assign({}, this.form)
          forms.seksi = JSON.stringify(forms.seksi)
          
          await post(`admin/user/update`, {
            data: forms
          })
          .then((response) => {
            let res = response.data

            if (res.status === 200) {
              this.$emit('load', true)
                
              this.process.form = false

              this.dialog.snackbar = true
              this.message.success = res.message
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>